import { CompaniesComponent } from "./companies.component";
export const CompaniesModule = angular
    .module('companies', [])
    .component(CompaniesComponent.selector, CompaniesComponent.component)
    .name;
//# sourceMappingURL=companies.module.js.map